import { type ElementType, type ReactElement } from "react";

import { styled } from "simplydo/react/styled";

import { Dropdown } from "../dropdown/Dropdown";
import type { FormDropdownProps } from "./Form.types";
import { FormField } from "./FormField";

const FormDropdownComponent = (props: FormDropdownProps): ReactElement => {
  const { control, variant = "outline", ...rest } = props;
  return (
    <FormField
      {...rest}
      variant={variant}
      control={(control as ElementType) || Dropdown}
    />
  );
};

export const FormDropdown = styled(FormDropdownComponent)``;
